// Global flag to prevent multiple simultaneous initializations
let isInitializing = false;

export const useStoreInitialization = () => {
  const layoutStore = useLayoutStore();

  const initializeStores = async () => {
    // Skip on server-side
    if (import.meta.server) return;

    // If the stores are already initialized or currently initializing
    if (layoutStore.boot || isInitializing) {
      return;
    }

    isInitializing = true;

    try {

      // Initialize stores
      const messengerStore = useMessengerStore();
      const userStore = useUserStore();
      const segmentStore = useSegmentStore();
      const workspaceStore = useWorkspaceStore();
      const languageStore = useLanguageStore();
      const newscenterStore = useNewscenterStore();
      const helpdeskStore = useHelpdeskStore();
      const teamStore = useTeamStore();
      const planStore = usePlanStore();


      // Initialize stores
      await userStore.init();
      await workspaceStore.fetchWorkspaces();
      await workspaceStore.fetchFeatures();
      await newscenterStore.init();
      await languageStore.fetchLanguages();
      await helpdeskStore.init();
      await teamStore.init();
      await userStore.fetchUsers();
      await planStore.fetchPlans();
      await messengerStore.fetchMessenger();

      // These don't need to be awaited
      segmentStore.fetchContactsSegments();
      segmentStore.fetchCompaniesSegments();

      layoutStore.boot = true;
    }
    catch (error) {
      layoutStore.boot = false;
      console.error('Store initialization failed:', error);
    }
    finally {
      isInitializing = false;
    }
  };

  return {
    initializeStores
  };
};